import { useEffect, useRef } from 'react';
import { backend, screenStatus, useApp } from '../data/store';
import { SandboxBackend } from '../data/sandbox';

/** Notices when a paired screen stops sending heartbeats and records it once in the activity feed. */
export function usePresenceWatch() {
  const ws = useApp((s) => s.ws);
  const now = useApp((s) => s.now);
  const prev = useRef(new Map<string, string>());
  useEffect(() => {
    if (!ws) return;
    for (const s of ws.screens) {
      const st = screenStatus(s, now);
      const before = prev.current.get(s.id);
      prev.current.set(s.id, st);
      if (before && before !== 'offline' && before !== 'unpaired' && st === 'offline' && backend instanceof SandboxBackend) {
        void backend.noteOffline(s.id, s.lastSeenAt ?? new Date(0).toISOString());
      }
    }
  }, [ws, now]);
}
